import {
    ElementRef,
    Injectable
} from '@angular/core';
import { first, isNil, last } from 'lodash';
import {
    IDatiqMapGeoJsonFeature,
    mapStyleSimple,
    mcMapFeatureStyles
} from './models';

@Injectable({
    providedIn: 'any',
})
export class MapService {

    create(ref: ElementRef): google.maps.Map {
        if (typeof google === 'undefined' || isNil(google)) {
            return null;
        }

        return new google.maps.Map(
            ref.nativeElement,
            {
                zoom: 5,
                minZoom: 3,
                disableDefaultUI: true,
                styles: mapStyleSimple,
                zoomControl: true
            }
        );
    }

    setCenter(
        map: google.maps.Map,
        originLatLong: { lat: number; lng: number },
        destinationLatLong: { lat: number; lng: number }
    ): void {
        map.panTo(this.calculateMidPoint(originLatLong, destinationLatLong));
    }

    setAreas(
        map: google.maps.Map,
        originGeoJson: IDatiqMapGeoJsonFeature,
        destinationGeoJson: IDatiqMapGeoJsonFeature,
    ): any {
        const origin = new google.maps.Data();

        origin.addGeoJson(originGeoJson);
        origin.setStyle(mcMapFeatureStyles);
        origin.setMap(map);

        const destination = new google.maps.Data();

        destination.addGeoJson(destinationGeoJson);
        destination.setStyle(mcMapFeatureStyles);
        destination.setMap(map);

        return {
            origin,
            destination
        };
    }

    renderDirections(
        map: google.maps.Map,
        directions: google.maps.DirectionsResult,
        directionsRenderer: google.maps.DirectionsRenderer,
    ) {
        const start = first(directions.routes[0].legs).start_location;
        const end = last(directions.routes[0].legs).end_location;

        // pickup/dropoff assets are not sized the same, we should probably fix that
        const originMarker = new google.maps.Marker({
            position: start,
            icon: {
                url: '/assets/mc-map-lane/pickup.svg',
            },
            map,
        });
        const destinationMarker = new google.maps.Marker({
            position: end,
            icon: {
                anchor: new google.maps.Point(12, 20),
                url: '/assets/mc-map-lane/dropoff.svg',
            },
            map,
        });

        directionsRenderer.setDirections(directions);

        return {
            originMarker,
            destinationMarker
        }
    }

    private calculateMidPoint(
        origin: { lat: number; lng: number },
        destination: { lat: number; lng: number },
    ): { lat: number; lng: number } {
        const midLat = (origin.lat + destination.lat) / 2;
        const midLng = (origin.lng + destination.lng) / 2;

        return { lat: midLat, lng: midLng };
    }
}
